import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const policy = createApi({
  reducerPath: "policy",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    getTermsAndCondition: builder.query({
      query: () => ({
        url: `v1/gc/whatsapp-config/terms-condition/`,
        method: "GET",
      }),
    }),

    getPrivacyPolicy: builder.query({
      query: () => ({
        url: `v1/gc/whatsapp-config/privacy-policy/`,
        method: "GET",
      }),
    }),

    updateTermAndCondition: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/gc/whatsapp-config/1`,
        method: "PATCH",
        body,
      }),
    }),

    updatePrivacyPolicy: builder.mutation({
      query: ({ body }) => ({
        url: `v1/gc/whatsapp-config/1/`,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const {
  useGetTermsAndConditionQuery,
  useGetPrivacyPolicyQuery,
  useUpdateTermAndConditionMutation,
  useUpdatePrivacyPolicyMutation,
} = policy;
